"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var CanvasBackground = function (_a) {
    var _b = _a.content, fileMetadata = _b.fileMetadata, createdAt = _b.createdAt, updatedAt = _b.updatedAt;
    if (fileMetadata) {
        /**
         * In preview player 'url' is presigned S3 url to image. (always unique url)
         * In real device 'url' is path to the file in device's file system. (path is not always unique)
         * So when real device we need to use 'lastmod' query parameter to tell device browser that image is not the same.
         * Note: 'lastmod' query paramter can't be used with S3 url. So we need to have this extra logic for both cases.
         * Note: The presigned url always start with 'https'.
         */
        var src = fileMetadata.url.startsWith('https')
            ? fileMetadata.url
            : "".concat(fileMetadata.url, "?lastmod=").concat(typeof updatedAt === 'number' ? updatedAt : createdAt);
        return (react_1.default.createElement("img", { src: src, style: {
                height: '100%',
                width: '100%',
                objectFit: 'contain'
            } }));
    }
    return react_1.default.createElement(react_1.Fragment, null);
};
exports.default = CanvasBackground;
//# sourceMappingURL=CanvasBackground.js.map